var render = function render(){var _vm=this,_c=_vm._self._c;return _c('template-post',{attrs:{"title":"Atualizar dúvida"},on:{"close":function($event){return _vm.$router.back()},"post":_vm.completeRegister}},[_c('div',[_c('form-fields',{attrs:{"fields":_vm.fields},on:{"save":_vm.completeRegister,"update:values":function($event){_vm.inputsValues = $event}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }